import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  Bell,
  UserCog,
  Target,
  MessageCircle,
  LogOut,
  ChevronLeft,
  ChevronRight,
} from 'lucide-react';
import { useAuthStore } from '../../stores/authStore.js';
import { useLogout } from '../../features/auth/useAuth.js';
import { useWhatsAppEstado } from '../../features/whatsapp/useWhatsApp.js';

const NAV_BASE = [
  { to: '/dashboard',     label: 'Dashboard',     Icon: LayoutDashboard },
  { to: '/leads',         label: 'Leads',         Icon: Users },
  { to: '/recordatorios', label: 'Recordatorios', Icon: Bell },
];

const NAV_ADMIN = [
  ...NAV_BASE,
  { to: '/whatsapp',  label: 'WhatsApp',  Icon: MessageCircle },
  { to: '/usuarios',  label: 'Usuarios',  Icon: UserCog },
  { to: '/objetivos', label: 'Objetivos', Icon: Target },
];

function getNav(rol) {
  return rol === 'admin' ? NAV_ADMIN : NAV_BASE;
}

export default function Sidebar({ collapsed, onToggle }) {
  const usuario = useAuthStore((s) => s.usuario);
  const logout = useLogout();
  const nav = getNav(usuario?.rol);
  const esAdmin = usuario?.rol === 'admin';
  const { data: waEstado } = useWhatsAppEstado({ enabled: esAdmin });
  const waDesconectado = esAdmin && waEstado?.estado && waEstado.estado !== 'open' && waEstado.estado !== 'no_configurado';

  return (
    <aside
      className="fixed left-0 top-0 h-screen bg-[#0D2B5C] flex flex-col transition-all duration-200 z-40"
      style={{ width: collapsed ? 64 : 256 }}
    >
      {/* Header */}
      <div className="flex items-center border-b border-white/10" style={{ minHeight: 64 }}>
        {collapsed ? (
          <button
            onClick={onToggle}
            className="flex-1 flex items-center justify-center py-4 text-white/70 hover:text-white transition-colors"
            title="Expandir"
          >
            <img src="/logo-escudo.png" alt="ISADA" className="h-7 w-auto" style={{ filter: 'brightness(0) invert(1)' }} />
          </button>
        ) : (
          <>
            <div className="flex items-center gap-3 flex-1 min-w-0 px-4 py-4">
              <img src="/logo-escudo.png" alt="ISADA" className="h-8 w-auto shrink-0" style={{ filter: 'brightness(0) invert(1)' }} />
              <div className="min-w-0">
                <p className="font-['Raleway'] font-bold text-white text-sm leading-tight truncate">Instituto ISADA</p>
                <p className="font-['Inter'] text-white/50 text-[10px] truncate">CRM Interno</p>
              </div>
            </div>
            <button
              onClick={onToggle}
              className="pr-4 text-white/70 hover:text-white transition-colors shrink-0"
              title="Colapsar"
            >
              <ChevronLeft size={18} />
            </button>
          </>
        )}
      </div>

      {/* Nav */}
      <nav className="flex-1 px-2 py-3 overflow-y-auto">
        {nav.map(({ to, label, Icon }) => {
          const showAlert = to === '/whatsapp' && waDesconectado;
          return (
            <NavLink
              key={to}
              to={to}
              title={collapsed ? label : undefined}
              className={({ isActive }) =>
                'relative flex items-center gap-3 px-3 py-2.5 rounded-md mb-1 transition-colors font-["Raleway"] ' +
                (isActive
                  ? 'bg-white/10 text-white font-semibold'
                  : 'text-white/70 hover:bg-white/5 hover:text-white')
              }
            >
              <span className="relative shrink-0">
                <Icon size={18} />
                {showAlert && (
                  <span className="absolute -top-1 -right-1 w-2 h-2 bg-red-400 rounded-full" />
                )}
              </span>
              {!collapsed && (
                <span className="text-sm truncate flex-1">{label}</span>
              )}
              {!collapsed && showAlert && (
                <span className="text-[10px] text-red-400 font-semibold">!</span>
              )}
            </NavLink>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="px-2 py-3 border-t border-white/10">
        {!collapsed && (
          <p className="px-3 text-white/40 text-xs font-['Inter'] mb-2 truncate">
            {usuario?.nombre} · {usuario?.rol}
          </p>
        )}
        <button
          onClick={logout}
          title={collapsed ? 'Cerrar sesión' : undefined}
          className="flex items-center gap-3 px-3 py-2.5 rounded-md w-full text-white/70 hover:bg-white/5 hover:text-white transition-colors"
        >
          <LogOut size={18} className="shrink-0" />
          {!collapsed && <span className="text-sm font-['Raleway']">Cerrar sesión</span>}
        </button>
      </div>
    </aside>
  );
}
